module.exports = __webpack_public_path__ + "static/assets/53d2d6182c354c39ef6c27b814613640.png";